import { Flex, Typography } from 'antd';
import { Config } from '@copilot/common/config';
import Popover from '@copilot/common/components/containers/tooltips/popover';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { AiIcon } from '@copilot/common/components/ai/aiIcon/aiIcon';
import styles from './replyPredictionHeader.module.less';

/**
 * [Presentation] Reply Prediction header + info icon
 * @constructor
 */
export function ReplyPredictionHeader() {
    function getInfoIcon() {
        return (
            <Popover
                overlayClassName={styles.replyPredictionPopover}
                content={
                    <div className={styles.replyPredictionPopoverContent}>
                        <Typography.Paragraph>
                            Prospects that show a higher likelihood of reply are surfaced at the top
                            of your search list. Invites are prioritized to them first.
                        </Typography.Paragraph>
                        {Config.replyPredictionArticleURL && (
                            <Typography.Link
                                href={Config.replyPredictionArticleURL}
                                target="_blank"
                                strong
                                underline
                            >
                                Learn more about Reply Prediction
                            </Typography.Link>
                        )}
                    </div>
                }
                trigger="click"
            >
                <Typography.Link>
                    <QuestionCircleOutlined />
                </Typography.Link>
            </Popover>
        );
    }
    return (
        <Flex gap={8} align="center">
            <span className={styles.replyPredictionHeaderText}>Reply Prediction</span>
            <AiIcon className={styles.replyPredictionAiIcon} />
            {getInfoIcon()}
        </Flex>
    );
}
